import { useTranslation } from 'react-i18next'

interface EmptyStateProps {
  readonly icon: React.ReactNode
  readonly title: string
  readonly description?: string
  readonly action?: React.ReactNode
}

export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 animate-fade-in">
      <div
        className="mb-4 flex h-16 w-16 items-center justify-center rounded-2xl"
        style={{
          backgroundColor: 'color-mix(in srgb, var(--tg-theme-hint-color) 8%, transparent)',
          color: 'var(--tg-theme-hint-color)',
        }}
      >
        {icon}
      </div>
      <h3 className="mb-1 text-base font-semibold text-tg-text">
        {title}
      </h3>
      {description && (
        <p className="mb-4 max-w-xs text-center text-sm text-tg-hint">
          {description}
        </p>
      )}
      {action}
    </div>
  )
}
